import { InduccionEstado } from "src/app/models/common/enumModel";
import { IFilterInduccionModel } from "src/app/models/interfaces/induccion/IFilterInduccionModel";

export class FilterSolicitudPersonaPendienteInduccionModel implements IFilterInduccionModel {
    idInducciones: number[];
    idEstado: InduccionEstado;
    estados: number[];
    fechaInicioInduccion?: Date;
    fechaFinInduccion?: Date;
    idCompania: number;
    

    nombreEmpleado: string;
    nroDocumento: string;
    codigoSolicitud: string;
    solicitante: string;
    sedes: number[];
    fechaInicioAprobacion?: Date;
    fechaFinAprobacion?: Date;
    nombreContratista: string;
    page: number;
    pageSize: number;

    constructor(){
        this.idInducciones = new Array<number>();
        this.idEstado = InduccionEstado.PENDIENTE;
        this.estados = [];
        this.nombreEmpleado = '';
        this.nroDocumento = '';
        this.codigoSolicitud = '';
        this.solicitante = '';
        this.sedes = [];
        this.nombreContratista = '';
        this.page = 1;
        this.pageSize = 30;
        this.idCompania = 0;
    }
}